import { createI18n } from 'vue-i18n'
import ru from './locales/ru.json'
import en from './locales/en.json'
import uk from './locales/uk.json'

// Определяем язык по умолчанию
const getDefaultLocale = () => {
    // Сначала проверяем localStorage
    const saved = localStorage.getItem('locale')
    if (saved && ['ru', 'en', 'uk'].includes(saved)) {
        return saved
    }

    // Затем определяем по браузеру
    const browserLang = navigator.language.toLowerCase()
    if (browserLang.startsWith('ru')) return 'ru'
    if (browserLang.startsWith('uk')) return 'uk'
    return 'en' // По умолчанию английский
}

const i18n = createI18n({
    legacy: false, // Используем Composition API
    locale: getDefaultLocale(),
    fallbackLocale: 'en',
    messages: {
        ru,
        en,
        uk
    },
    globalInjection: true // Позволяет использовать $t в template
})

// Функция для смены языка
export const setLocale = (locale) => {
    if (!['ru', 'en', 'uk'].includes(locale)) {
        console.warn(`Unsupported locale: ${locale}`)
        return
    }

    // ИСПРАВЛЕНИЕ: используем правильный способ установки локали
    i18n.global.locale.value = locale
    localStorage.setItem('locale', locale)
    document.documentElement.setAttribute('lang', locale)
}

// Функция для получения текущего языка
export const getLocale = () => i18n.global.locale.value

// Список доступных языков
export const availableLocales = [
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'uk', name: 'Українська', flag: '🇺🇦' }
]

export default i18n